type ElectronScreenTypesApi = {
  resetScreenTypes?: () => Promise<unknown>;
};

function electronApi(): ElectronScreenTypesApi | undefined {
  return (window as unknown as { electronAPI?: ElectronScreenTypesApi })
    .electronAPI;
}

/**
 * Drop the desktop's persisted "reopen the last page" state.
 *
 * The main process stores a screenType per screen and reloads it at window
 * creation, with no notion of which user was signed in. Without this, the page
 * a user was last on is restored for whoever launches the app next. Resolves
 * false in a browser, where there is no bridge and nothing to reset.
 */
export async function resetDesktopScreenTypes(): Promise<boolean> {
  const api = electronApi();
  if (!api?.resetScreenTypes) return false;
  try {
    await api.resetScreenTypes();
    return true;
  } catch {
    // A broken bridge must never block signing out.
    return false;
  }
}
